import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import CatalogoOrganizacion from "../../../catalogos/catalogoOrganizacion";
import CatalogoPersona from "../../../catalogos/catalogoPersona";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
} from "../../../util/varios";
import moment from "moment";
import { Checkbox, Input, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, InfoButton, SuccessButton } from "../../../ui/buttons/Button";
export const ActualizarUsuario = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [dato, setDato] = useState([3]);
  const [dato2, setDato2] = useState("");
  const [password, setPassword] = useState("");
  const [activate, setActivate] = useState(false);
  const [usuario, setUsuario] = useState();
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [correo, setCorreo] = useState("");
  const [modulos, setModulos] = useState({
    accedocuenta: "0",
    accrenovalicencia: "0",
    acclicenciafunciona: "0",
    accpermdecla: "0",
    accacreditacion: "0",
    accexoncomercio: "0",
    accverifica: "0",
    accconfigcome: "0",
    accrepgensector: "0",
    accreppatente: "0",
    accrepactividad: "0",
    accrepfecdecla: "0",
    accrepmondecla: "0",
    accimppatente: "0",
    accimpedoctasectcome: "0",
    accimptramites: "0",
  });
  const [permisos, setPermisos] = useState({
    acccontribuyente: "0000",
    accactividad: "0000",
    accdeclaraciones: "000",
    accacticontri: "00",
    accagente: "0000",
    accusuariocome: "0000",
  });
  const [url, setUrl] = useState("");
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [desde, setDesde] = useState(0);
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdOrg = useRef();
  const txtNomOrg = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const chkLiquidador = useRef();
  const chkPoseeImpresora = useRef();
  const radioPuertoU = useRef();
  const radioPuertoP = useRef();
  const radioPuertoS = useRef();

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }
    if (op.reportes != null) {
      setUrl(op.reportes.trim());
    } else {
      setUrl("");
    }
  }, [props.operacion]);

  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/comun/actualizarusuario/${operacion}`;
    console.log(body);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let per = JSON.parse(localStorage.getItem("idusuario"));
          if (per === txtIdUsuario.current.value) {
            localStorage.setItem(
              "liquidador",
              JSON.stringify(chkLiquidador.current.checked)
            );
            localStorage.setItem(
              "accedocuenta",
              JSON.stringify(modulos.accedocuenta)
            );
            localStorage.setItem(
              "accrenovalicencia",
              JSON.stringify(modulos.accrenovalicencia)
            );
            localStorage.setItem(
              "accconfigcome",
              JSON.stringify(modulos.accconfigcome)
            );
            localStorage.setItem(
              "accrepgensector",
              JSON.stringify(modulos.accrepgensector)
            );
            localStorage.setItem(
              "accexoncomercio",
              JSON.stringify(modulos.accexoncomercio)
            );
            localStorage.setItem(
              "accpermdecla",
              JSON.stringify(modulos.accpermdecla)
            );
            localStorage.setItem(
              "acclicenciafunciona",
              JSON.stringify(modulos.acclicenciafunciona)
            );
            localStorage.setItem(
              "accacreditacion",
              JSON.stringify(modulos.accacreditacion)
            );
            localStorage.setItem(
              "accverifica",
              JSON.stringify(modulos.accverifica)
            );
            localStorage.setItem(
              "accreppatente",
              JSON.stringify(modulos.accreppatente)
            );
            localStorage.setItem(
              "accrepactividad",
              JSON.stringify(modulos.accrepactividad)
            );
            localStorage.setItem(
              "accrepfecdecla",
              JSON.stringify(modulos.accrepfecdecla)
            );
            localStorage.setItem(
              "accrepmondecla",
              JSON.stringify(modulos.accrepmondecla)
            );
            localStorage.setItem(
              "accimppatente",
              JSON.stringify(modulos.accimppatente)
            );
            localStorage.setItem(
              "accimpedoctasectcome",
              JSON.stringify(modulos.accimpedoctasectcome)
            );
            localStorage.setItem(
              "accimptramites",
              JSON.stringify(modulos.accimptramites)
            );
            localStorage.setItem(
              "acccontribuyente",
              JSON.stringify(permisos.acccontribuyente)
            );
            localStorage.setItem(
              "accactividad",
              JSON.stringify(permisos.accactividad)
            );
            localStorage.setItem(
              "accdeclaraciones",
              JSON.stringify(permisos.accdeclaraciones)
            );
            localStorage.setItem(
              "accacticontri",
              JSON.stringify(permisos.accacticontri)
            );
            localStorage.setItem(
              "accagente",
              JSON.stringify(permisos.accagente)
            );
            localStorage.setItem(
              "accusuariocome",
              JSON.stringify(permisos.accusuariocome)
            );
          }
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido registrado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido modificado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El usuario " +
                response.data.iduser +
                " ha sido eliminado de manera satisfactoria.",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const datosOrga = (idorganizacion) => {
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idorganizacion}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          if (response.data !== "") {
            txtNomOrg.current.value = response.data.nombre;
            txtCedula.current.focus();
            setContar(contar + 1);
          } else {
            txtNomOrg.current.value = "";
            txtIdOrg.current.value = "";
            setTitulo("Error");
            setMsg("La Organizacion no existe.");
            setMostrar(true);
            setContar(contar + 1);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }
          setHabilitadoNU(true);
          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment.utc(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              setTabIndex1(0);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarOrg = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        datosOrga(event.target.value);
      } else {
        txtNomOrg.current.value = "";
        txtIdOrg.current.value = "";
      }
    }
  };

  const handleCloseCatalogo = () => {
    setMostrar2(false);
  };

  const handleAceptaCatalogo = (idOrg, nomOrg, razonOrg) => {
    setMostrar2(false);
    txtIdOrg.current.value = idOrg;
    txtNomOrg.current.value = nomOrg;
  };

  const catalogoOrg = () => {
    setMostrar2(true);
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };
  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = fnacPer;
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setMostrar1(false);
    setTitulo2("");
    setMsg2("");
    setDato([3]);
    setDato2("");
    setPassword("");
    setActivate(false);
    setCorreo("");
    setDesde(0);
    setModulos({
      accedocuenta: "0",
      accrenovalicencia: "0",
      acclicenciafunciona: "0",
      accpermdecla: "0",
      accacreditacion: "0",
      accexoncomercio: "0",
      accverifica: "0",
      accconfigcome: "0",
      accrepgensector: "0",
      accreppatente: "0",
      accrepactividad: "0",
      accrepfecdecla: "0",
      accrepmondecla: "0",
      accimppatente: "0",
      accimpedoctasectcome: "0",
      accimptramites: "0",
    });
    setPermisos({
      accvalortipocat: "0000",
      acccontribuyente: "0000",
      supercat: false,
      accavaluo: "0000",
      accdepreciacioncat: "0000",
      accvalorterrecat: "0000",
      accrepvalconstruc: "0000",
      accusuariocat: "0000",
      accactividad: "0000",
      accdeclaraciones: "000",
      accacticontri: "00",
      accagente: "0000",
      accusuariocome: "0000",
    });
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleChangeOtro = (event) => {
    setModulos({
      ...modulos,
      [event.target.name]: event.target.value === "true" ? "1" : "0",
    });
  };

  const handleChangeChek = (event) => {
    var num;
    num = event.target.checked === true ? "1" : "0";
    if (event.target.name === "acccontribuyente") {
      if (event.target.id === "chkRegContriConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.acccontribuyente.toString().substring(1, 2) +
            permisos.acccontribuyente.toString().substring(2, 3) +
            permisos.acccontribuyente.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.acccontribuyente.toString().substring(0, 1) +
            num +
            permisos.acccontribuyente.toString().substring(2, 3) +
            permisos.acccontribuyente.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.acccontribuyente.toString().substring(0, 1) +
            permisos.acccontribuyente.toString().substring(1, 2) +
            num +
            permisos.acccontribuyente.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkRegContriElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.acccontribuyente.toString().substring(0, 1) +
            permisos.acccontribuyente.toString().substring(1, 2) +
            permisos.acccontribuyente.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkRegContriTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accactividad") {
      if (event.target.id === "chkActiviEconoConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accactividad.toString().substring(1, 2) +
            permisos.accactividad.toString().substring(2, 3) +
            permisos.accactividad.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkActiviEconoInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accactividad.toString().substring(0, 1) +
            num +
            permisos.accactividad.toString().substring(2, 3) +
            permisos.accactividad.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkActiviEconoEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accactividad.toString().substring(0, 1) +
            permisos.accactividad.toString().substring(1, 2) +
            num +
            permisos.accactividad.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkActiviEconoElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accactividad.toString().substring(0, 1) +
            permisos.accactividad.toString().substring(1, 2) +
            permisos.accactividad.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkActiviEconoTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accdeclaraciones") {
      if (event.target.id === "chkDeclaracionesInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accdeclaraciones.toString().substring(1, 2) +
            permisos.accdeclaraciones.toString().substring(2, 3),
        });
      } else if (event.target.id === "chkDeclaracionesElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accdeclaraciones.toString().substring(0, 1) +
            num +
            permisos.accdeclaraciones.toString().substring(2, 3),
        });
      } else if (event.target.id === "chkDeclaracionesCar") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accdeclaraciones.toString().substring(0, 1) +
            permisos.accdeclaraciones.toString().substring(1, 2) +
            num,
        });
      }
    } else if (event.target.name === "accacticontri") {
      if (event.target.id === "chkUsuarioWebInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num + permisos.accacticontri.toString().substring(1, 2),
        });
      } else if (event.target.id === "chkUsuarioWebElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accacticontri.toString().substring(0, 1) + num,
        });
      } else if (event.target.id === "chkUsuarioWebTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "11" : "00",
        });
      }
    } else if (event.target.name === "accusuariocome") {
      if (event.target.id === "chkUsuarioComeConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accusuariocome.toString().substring(1, 2) +
            permisos.accusuariocome.toString().substring(2, 3) +
            permisos.accusuariocome.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkUsuarioComeInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariocome.toString().substring(0, 1) +
            num +
            permisos.accusuariocome.toString().substring(2, 3) +
            permisos.accusuariocome.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkUsuarioComeEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariocome.toString().substring(0, 1) +
            permisos.accusuariocome.toString().substring(1, 2) +
            num +
            permisos.accusuariocome.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkUsuarioComeElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accusuariocome.toString().substring(0, 1) +
            permisos.accusuariocome.toString().substring(1, 2) +
            permisos.accusuariocome.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkUsuarioComeTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: event.target.checked ? "1111" : "0000",
        });
      }
    } else if (event.target.name === "accagente") {
      if (event.target.id === "chkOrganismoConsul") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            num +
            permisos.accagente.toString().substring(1, 2) +
            permisos.accagente.toString().substring(2, 3) +
            permisos.accagente.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkOrganismoInc") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accagente.toString().substring(0, 1) +
            num +
            permisos.accagente.toString().substring(2, 3) +
            permisos.accagente.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkOrganismoEdit") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accagente.toString().substring(0, 1) +
            permisos.accagente.toString().substring(1, 2) +
            num +
            permisos.accagente.toString().substring(3, 4),
        });
      } else if (event.target.id === "chkOrganismoElim") {
        setPermisos({
          ...permisos,
          [event.target.name]:
            permisos.accagente.toString().substring(0, 1) +
            permisos.accagente.toString().substring(1, 2) +
            permisos.accagente.toString().substring(2, 3) +
            num,
        });
      } else if (event.target.id === "chkOrganismoTodo") {
        setPermisos({
          ...permisos,
          [event.target.name]: "1111",
        });
      }
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
          txtConfirmPassword.current.focus();
        } else {
          txtIdOrg.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            setMostrar(true);
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            setMostrar(true);
            event.target.value = "";
          } else {
            txtCelUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputCelUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            setMostrar(true);
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setTitulo("Información");
          setMsg("Las Contraseñas no coinciden.");
          setMostrar(true);
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de Email invalido.");
            //setMostrar(true);
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            //setMostrar(true);
            event.target.value = "";
          } else {
            txtCelUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputCelUsuario") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtLogin.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Usuario no debe estar vacio");
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      setTitulo("Error");
      setMsg("La Contraseña no debe estar vacia");
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      setTitulo("Error");
      setMsg("La Confirmación de la Contraseña no debe estar vacia");
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      setTitulo("Error");
      setMsg("Las Contraseñas no coinciden");
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtIdOrg.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Código de la rganización no debe estar vacio");
      sigue = false;
      setTabIndex(0);
      txtIdOrg.current.focus();
    } else if (txtNomOrg.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Nombre de la rganización no debe estar vacio");
      sigue = false;
      setTabIndex(0);
      txtNomOrg.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La cedula no debe estar vacia");
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Los nombres no deben estar vacios");
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Los Apellidos no deben estar vacio");
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La direccion del Usuario no debe estar vacia");
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("La fecha de nacimiento no debe estar vacia");
      sigue = false;
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var user = [];
      var datoPer = [];
      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        idorganizacion: txtIdOrg.current.value,
        liquidador: chkLiquidador.current.checked,
        persona: txtCedula.current.value,
        poseeimpresora: chkPoseeImpresora.current.checked,
        puerto: radioPuertoU.current.checked
          ? 0
          : radioPuertoP.current.checked
          ? 1
          : radioPuertoS.current.checked
          ? 2
          : 1,
        accedocuenta: modulos.accedocuenta,
        accrenovalicencia: modulos.accrenovalicencia,
        acclicenciafunciona: modulos.acclicenciafunciona,
        accpermdecla: modulos.accpermdecla,
        accacreditacion: modulos.accacreditacion,
        accexoncomercio: modulos.accexoncomercio,
        accverifica: modulos.accverifica,
        accconfigcome: modulos.accconfigcome,
        accrepgensector: modulos.accrepgensector,
        accreppatente: modulos.accreppatente,
        accrepactividad: modulos.accrepactividad,
        accrepfecdecla: modulos.accrepfecdecla,
        accrepmondecla: modulos.accrepmondecla,
        accimppatente: modulos.accimppatente,
        accimpedoctasectcome: modulos.accimpedoctasectcome,
        accimptramites: modulos.accimptramites,
        acccontribuyente: permisos.acccontribuyente,
        accactividad: permisos.accactividad,
        accdeclaraciones: permisos.accdeclaraciones,
        accacticontri: permisos.accacticontri,
        accagente: permisos.accagente,
        accusuariocome: permisos.accusuariocome,
      });
      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim().toUpperCase(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim().toUpperCase(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim().toUpperCase(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });
      setUsuario(user);
      setPersona(datoPer);
      setActivate(true);
      setContar2(0);
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      procesarRegistro(body);
    } else {
      setMostrar(true);
    }
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.render();
    blanquear();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);
        setTabIndex(0);
        setTabIndex1(0);
        console.log(props.operacion);

        if (props.usuario) {
          setModulos({
            accedocuenta:
              props.usuario.accedocuenta === null
                ? "0"
                : props.usuario.accedocuenta,
            accrenovalicencia:
              props.usuario.accrenovalicencia === null
                ? "0"
                : props.usuario.accrenovalicencia,
            acclicenciafunciona:
              props.usuario.acclicenciafunciona === null
                ? "0"
                : props.usuario.acclicenciafunciona,
            accpermdecla:
              props.usuario.accpermdecla === null
                ? "0"
                : props.usuario.accpermdecla,
            accacreditacion:
              props.usuario.accacreditacion === null
                ? "0"
                : props.usuario.accacreditacion,
            accexoncomercio:
              props.usuario.accexoncomercio === null
                ? "0"
                : props.usuario.accexoncomercio,
            accverifica:
              props.usuario.accverifica === null
                ? "0"
                : props.usuario.accverifica,
            accconfigcome:
              props.usuario.accconfigcome === null
                ? "0"
                : props.usuario.accconfigcome,
            accrepgensector:
              props.usuario.accrepgensector === null
                ? "0"
                : props.usuario.accrepgensector,
            accreppatente:
              props.usuario.accreppatente === null
                ? "0"
                : props.usuario.accreppatente,
            accrepactividad:
              props.usuario.accrepactividad === null
                ? "0"
                : props.usuario.accrepactividad,
            accrepfecdecla:
              props.usuario.accrepfecdecla === null
                ? "0"
                : props.usuario.accrepfecdecla,
            accrepmondecla:
              props.usuario.accrepmondecla === null
                ? "0"
                : props.usuario.accrepmondecla,
            accimppatente:
              props.usuario.accimppatente === null
                ? "0"
                : props.usuario.accimppatente,
            accimpedoctasectcome:
              props.usuario.accimpedoctasectcome === null
                ? "0"
                : props.usuario.accimpedoctasectcome,
            accimptramites:
              props.usuario.accimptramites === null
                ? "0"
                : props.usuario.accimptramites,
          });
          setPermisos({
            acccontribuyente:
              props.usuario.acccontribuyente === null
                ? "0000"
                : props.usuario.acccontribuyente,
            accactividad:
              props.usuario.accactividad === null
                ? "0000"
                : props.usuario.accactividad,
            accdeclaraciones:
              props.usuario.accdeclaraciones === null
                ? "000"
                : props.usuario.accdeclaraciones,
            accacticontri:
              props.usuario.accacticontri === null
                ? "00"
                : props.usuario.accacticontri,
            accagente:
              props.usuario.accagente === null
                ? "0000"
                : props.usuario.accagente,
            accusuariocome:
              props.usuario.accusuariocome === null
                ? "0000"
                : props.usuario.accusuariocome,
          });
        } else {
          setModulos({
            accedocuenta: "0",
            accrenovalicencia: "0",
            acclicenciafunciona: "0",
            accpermdecla: "0",
            accacreditacion: "0",
            accexoncomercio: "0",
            accverifica: "0",
            accconfigcome: "0",
            accrepgensector: "0",
            accreppatente: "0",
            accrepactividad: "0",
            accrepfecdecla: "0",
            accrepmondecla: "0",
            accimppatente: "0",
            accimpedoctasectcome: "0",
            accimptramites: "0",
          });
          setPermisos({
            acccontribuyente: "0000",
            accactividad: "0000",
            accdeclaraciones: "000",
            accacticontri: "00",
            accagente: "0000",
            accusuariocome: "0000",
          });
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Usuario."
            : operacion === 2
            ? "Editar Usuario."
            : operacion === 3
            ? "Eliminar Usuario."
            : "Consultar Usuario."}
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i> 
        </a>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ul className="nav" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios2"
                data-bs-toggle="tab"
                data-bs-target="#tributarios2"
                type="button"
                role="tab"
                aria-controls="tributarios2"
                aria-selected="true"
              >
                Usuario
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link bg-blue-200 text-light"
                id="deuda-tab2"
                data-bs-toggle="tab"
                data-bs-target="#deuda2"
                type="button"
                role="tab"
                aria-controls="deuda2"
                aria-selected="false"
              >
                Permisos de Aplicaciones
              </a>
            </li>
          </ul>
          <div className="tab-content m-0 p-0" id="myTabContent">
            <div
              className="tab-pane fade show active m-0 p-0 mt-2"
              id="tributarios2"
              role="tabpanel"
              aria-labelledby="datosTributarios2"
            >
              <div className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <div class="col-3 m-0 mb-2 p-0">
                  <Input label = 'Código:'
                    disabled={true}
                    ref={txtIdUsuario}
                    defaultValue={props.usuario ? props.usuario.idusuario : ""}
                    id="inputCodigo"
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div class="col-6 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Usuario:'
                    autocomplete="off"
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtLogin}
                    defaultValue={props.usuario ? props.usuario.login : ""}
                    id="inputLogin"
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div class="col-6 m-0 p-0 d-flex align-items-center input-group-sm">
                  <Input label = 'Ingrese Contraseña:'
                    type={mostrarClave ? "text" : "password"}
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtPassword}
                    id="inputPassword"
                    onKeyUp={handleInputChange}
                />
                  <InfoButton icon = 'fa-eye-slash m-0'
                    className = 'rounded-0'
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    onClick={mostrarPassword}
                  />
                </div>
                <div class="col-6 m-0 p-0 pl-2 d-flex align-items-center input-group-sm">
                  <Input label = 'Confirmar Contraseña:'
                    type={mostrarClave1 ? "text" : "password"}
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtConfirmPassword}
                    id="inputConfirmPassword"
                    onKeyUp={handleInputChange}
                  />
                  <InfoButton icon = 'fa-eye-slash m-0'
                    className = 'rounded-0'
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    onClick={mostrarPassword1}
                  />
                </div>
              </div>
              <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex">
                <legend className="float-none w-auto m-0">Organización</legend>
                <div class="col-4 m-0 p-0">
                  <SearchInput label = 'Código:'
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtIdOrg}
                    id="inputIdOrg"
                    defaultValue={
                      props.usuario ? props.usuario.idorganizacion : ""
                    }
                    onKeyUp={validarOrg}
                    onBlur={validarOrg}
                    onClickButton = {catalogoOrg}
                    disabledButton = {operacion === 1 || operacion === 2 ? false : true}
                  />
                </div>
                  <Input 
                    disabled={true}
                    ref={txtNomOrg}
                    defaultValue={
                      props.usuario ? props.usuario.razonsocial : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
              </fieldset>
              <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
                <legend className="float-none w-auto m-0">Datos Personales</legend>
                <div class="col-5 m-0 mb-2 p-0 d-flex align-items-center input-group-sm">
                  <Select label = 'Cédula:'
                    disabled={!habilitadoNU}
                    ref={cmbNacionalidad}
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.nacionalidad
                        : ""
                    }
                  >
                    <option key="0" value="V">
                      V
                    </option>
                    <option key="1" value="E">
                      E
                    </option>
                  </Select>
                  <Input
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtCedula}
                    id="inputCedula"
                    defaultValue={
                      props.datospersonales ? props.datospersonales.cedula : ""
                    }
                    onKeyUp={validarPersona}
                    onBlur={validarPersona}
                  />
                  <InfoButton icon = 'fa-search m-0'
                    className = 'rounded-0'
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    onClick={catalogoPer}
                  />
                </div>
                <div class="col-4 m-0 mb-2 p-0 ml-auto">
                  <Input label = 'Fecha de Nacimiento:'
                    type="date"
                    disabled={!habilitadoNU}
                    ref={txtFechaNac}
                    id="inputFechaNac"
                    max={fechaSistema}
                    defaultValue={
                      props.datospersonales
                        ? moment.utc(props.datospersonales.fnacimiento).format(
                            "YYYY-MM-DD"
                          )
                        : ""
                    }
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div class="col-6 m-0 mb-2 p-0">
                  <Input label = 'Nombres:'
                    disabled={!habilitadoNU}
                    ref={txtNombreUsuario}
                    id="inputNomUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.nombres.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div class="col-6 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Apellidos:'
                    disabled={!habilitadoNU}
                    ref={txtApellidoUsuario}
                    id="inputApeUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.apellidos.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div class="col-12 m-0 mb-2 p-0">
                  <Textarea label = 'Dirección:'
                    style={{ height: 70 }}
                    disabled={!habilitadoNU}
                    ref={txtDireccionUsuario}
                    id="inputDireUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.direccion.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div class="col-4 m-0 mb-2 p-0">
                  <Input label = 'Correo:'
                    disabled={!habilitadoNU}
                    ref={txtEmailUsuario}
                    id="inputEmailUsuario"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.correoe !== null
                          ? props.datospersonales.correoe.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div class="col-4 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Telefono:'
                    disabled={!habilitadoNU}
                    ref={txtTlfUsuario}
                    id="inputTlfUsuario"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.tlf1 !== null
                          ? props.datospersonales.tlf1.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div class="col-4 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Celular:'
                    disabled={!habilitadoNU}
                    ref={txtCelUsuario}
                    id="inputCelUsuario"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.datospersonales
                        ? props.datospersonales.tlf2 !== null
                          ? props.datospersonales.tlf2.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div class="col-3 m-0 p-0">
                  <Select label = 'Sexo:'
                    disabled={!habilitadoNU}
                    ref={cmbSexo}
                    defaultValue={
                      props.datospersonales ? props.datospersonales.sexo : ""
                    }
                  >
                    <option key="0" value="M">
                      M
                    </option>
                    <option key="1" value="F">
                      F
                    </option>
                  </Select>
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <Checkbox label = 'Liquidador'
                    readOnly
                    id="checLiquidador"
                    disabled={deshabilitado}
                    ref={chkLiquidador}
                    defaultChecked={
                      props.usuario ? props.usuario.liquidador : false
                    }
                  />
                </div>
              </fieldset>
            </div>
            <div
              className="tab-pane fade"
              id="deuda2"
              role="tabpanel"
              aria-labelledby="deuda-tab2"
            >
              <ul className="nav" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link active bg-blue-100 text-light"
                    id="datosTributarios"
                    data-bs-toggle="tab"
                    data-bs-target="#tributarios"
                    type="button"
                    role="tab"
                    aria-controls="tributarios"
                    aria-selected="true"
                  >
                    Actualización
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link bg-blue-200 text-light"
                    disabled={
                      operacion === 1 || operacion === 3 ? true : deshabilitado
                    }
                    id="deuda-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#deuda"
                    type="button"
                    role="tab"
                    aria-controls="deuda"
                    aria-selected="false"
                  >
                    Reportes
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className=" rounded nav-link bg-blue-300 text-light"
                    disabled={
                      operacion === 1 || operacion === 3 ? true : deshabilitado
                    }
                    id="hist-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#historico"
                    type="button"
                    role="tab"
                    aria-controls="historico"
                    aria-selected="false"
                  >
                    Usuarios
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active border-azul rounded"
                  id="tributarios"
                  role="tabpanel"
                  aria-labelledby="datosTributarios"
                >
                  <div className="col-md-12 row mx-auto">
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">Registro de Contribuyente</div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriConsul"
                          name="acccontribuyente"
                          disabled={deshabilitado}
                          checked={
                            permisos.acccontribuyente
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Consultar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriInc"
                          name="acccontribuyente"
                          disabled={deshabilitado}
                          checked={
                            permisos.acccontribuyente
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriEdit"
                          name="acccontribuyente"
                          disabled={deshabilitado}
                          checked={
                            permisos.acccontribuyente
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Editar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriElim"
                          name="acccontribuyente"
                          disabled={deshabilitado}
                          checked={
                            permisos.acccontribuyente
                              .toString()
                              .substring(3, 4) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkRegContriTodo"
                          name="acccontribuyente"
                          disabled={deshabilitado}
                          checked={
                            permisos.acccontribuyente.toString() === "1111"
                          }
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>

                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">Actividades Económicas</div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoConsul"
                          name="accactividad"
                          disabled={deshabilitado}
                          checked={
                            permisos.accactividad.toString().substring(0, 1) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Consultar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoInc"
                          name="accactividad"
                          disabled={deshabilitado}
                          checked={
                            permisos.accactividad.toString().substring(1, 2) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoEdit"
                          name="accactividad"
                          disabled={deshabilitado}
                          checked={
                            permisos.accactividad.toString().substring(2, 3) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Editar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoElim"
                          name="accactividad"
                          disabled={deshabilitado}
                          checked={
                            permisos.accactividad.toString().substring(3, 4) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkActiviEconoTodo"
                          name="accactividad"
                          disabled={deshabilitado}
                          checked={permisos.accactividad.toString() === "1111"}
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Estados de Cuenta</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accedocuenta"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accedocuenta === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accedocuenta"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accedocuenta === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">Declaraciones Juradas</div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkDeclaracionesInc"
                          name="accdeclaraciones"
                          disabled={deshabilitado}
                          checked={
                            permisos.accdeclaraciones
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkDeclaracionesElim"
                          name="accdeclaraciones"
                          disabled={deshabilitado}
                          checked={
                            permisos.accdeclaraciones
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkDeclaracionesCar"
                          name="accdeclaraciones"
                          disabled={deshabilitado}
                          checked={
                            permisos.accdeclaraciones
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Cargar Deuda
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Renovación de Licencia IAE</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrenovalicencia"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accrenovalicencia === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrenovalicencia"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accrenovalicencia === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Licencia de Funcionamiento IAE
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="acclicenciafunciona"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.acclicenciafunciona === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="acclicenciafunciona"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.acclicenciafunciona === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Permiso Especial de Declaración Jurada
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accpermdecla"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accpermdecla === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accpermdecla"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accpermdecla === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Permiso para Acreditación</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accacreditacion"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accacreditacion === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accacreditacion"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accacreditacion === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Permiso Multa/Recargos/Intereses
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accexoncomercio"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accexoncomercio === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accexoncomercio"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accexoncomercio === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">
                        Actualización de Usuarios WEB
                      </div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioWebInc"
                          name="accacticontri"
                          disabled={deshabilitado}
                          checked={
                            permisos.accacticontri
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioWebElim"
                          name="accacticontri"
                          disabled={deshabilitado}
                          checked={
                            permisos.accacticontri
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioWebTodo"
                          name="accacticontri"
                          disabled={deshabilitado}
                          checked={permisos.accacticontri.toString() === "11"}
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>

                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">
                        Organismos(Agentes de Retención)
                      </div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkOrganismoConsul"
                          name="accagente"
                          disabled={deshabilitado}
                          checked={
                            permisos.accagente.toString().substring(0, 1) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Consultar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkOrganismoInc"
                          name="accagente"
                          disabled={deshabilitado}
                          checked={
                            permisos.accagente.toString().substring(1, 2) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkOrganismoEdit"
                          name="accagente"
                          disabled={deshabilitado}
                          checked={
                            permisos.accagente.toString().substring(2, 3) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Editar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkOrganismoElim"
                          name="accagente"
                          disabled={deshabilitado}
                          checked={
                            permisos.accagente.toString().substring(3, 4) ===
                            "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkOrganismoTodo"
                          name="accagente"
                          disabled={deshabilitado}
                          checked={permisos.accagente.toString() === "1111"}
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="deuda"
                  role="tabpanel"
                  aria-labelledby="deuda-tab"
                >
                  <div className="col-md-12 row mx-auto border-azul rounded">
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Listado General por Sector</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepgensector"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accrepgensector === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepgensector"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accrepgensector === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Listado por Nº de Patente</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accreppatente"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accreppatente === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accreppatente"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accreppatente === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Listado por Código de Actividad
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepactividad"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accrepactividad === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepactividad"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accrepactividad === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Listado por Fecha de Declaración
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepfecdecla"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accrepfecdecla === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepfecdecla"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accrepfecdecla === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Listado por Monto Declarado
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepmondecla"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accrepmondecla === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accrepmondecla"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accrepmondecla === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Impresión de Patente</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accimppatente"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accimppatente === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accimppatente"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accimppatente === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">
                        Imprimir Edo. Cuenta por Sector
                      </div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accimpedoctasectcome"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accimpedoctasectcome === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accimpedoctasectcome"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accimpedoctasectcome === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Impresión de Tramites</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accimptramites"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accimptramites === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accimptramites"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accimptramites === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="historico"
                  role="tabpanel"
                  aria-labelledby="hist-tab"
                >
                  <div className="col-md-12 row mx-auto">
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-5">Módulo de Usuarios</div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeConsul"
                          name="accusuariocome"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariocome
                              .toString()
                              .substring(0, 1) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Consultar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeInc"
                          name="accusuariocome"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariocome
                              .toString()
                              .substring(1, 2) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Incluir
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeEdit"
                          name="accusuariocome"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariocome
                              .toString()
                              .substring(2, 3) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Editar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeElim"
                          name="accusuariocome"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariocome
                              .toString()
                              .substring(3, 4) === "1"
                          }
                          onChange={handleChangeChek}
                        />
                        Eliminar
                        <a> &nbsp; </a>
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkUsuarioComeTodo"
                          name="accusuariocome"
                          disabled={deshabilitado}
                          checked={
                            permisos.accusuariocome.toString() === "1111"
                          }
                          onChange={handleChangeChek}
                        />
                        Todas
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Configuración del Modulo</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accconfigcome"
                            disabled={deshabilitado}
                            id="inlineRadio1"
                            value={true}
                            checked={modulos.accconfigcome === "1"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Disponible
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="accconfigcome"
                            disabled={deshabilitado}
                            id="inlineRadio2"
                            value={false}
                            checked={modulos.accconfigcome === "0"}
                            onChange={handleChangeOtro}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-6">Impresora</div>
                      <div className="col px-0">
                        <input
                          type="checkbox"
                          style={{ marginRight: "3px" }}
                          id="chkPoseeImpresora"
                          name="poseeimpresora"
                          ref={chkPoseeImpresora}
                          disabled={deshabilitado}
                          defaultChecked={
                            props.usuario ? props.usuario.poseeimpresora : false
                          }
                        />
                        Posee Impresora
                      </div>
                    </div>
                    <div className="col-md-12 row mx-auto rounded border my-2 py-2">
                      <div className="col-md-4">Puerto</div>
                      <div className="col row">
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="radioPuerto"
                            value="0"
                            id="radioUSB"
                            ref={radioPuertoU}
                            disabled={deshabilitado}
                            defaultChecked={
                              props.usuario
                                ? props.usuario.puerto === "0"
                                  ? true
                                  : false
                                : false
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            USB{" "}
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="radioPuerto"
                            value="1"
                            id="radioParalelo"
                            ref={radioPuertoP}
                            disabled={deshabilitado}
                            defaultChecked={
                              props.usuario
                                ? props.usuario.puerto === "1"
                                  ? true
                                  : false
                                : false
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            Paralelo
                          </label>
                        </div>
                        <div className="form-check form-check-inline col">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="radioPuerto"
                            value="2"
                            id="radioSerial"
                            ref={radioPuertoS}
                            disabled={deshabilitado}
                            defaultChecked={
                              props.usuario
                                ? props.usuario.puerto === "2"
                                  ? true
                                  : false
                                : false
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio2"
                          >
                            Serial
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <CatalogoOrganizacion
          titulo={titulo}
          mensaje={msg}
          show={mostrar2}
          onHideCancelaCatOrg={handleCloseCatalogo}
          onHideAceptaCatOrg={handleAceptaCatalogo}
        />
        <CatalogoPersona
          titulo={titulo}
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatPer={handleCloseCatalogoPer}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
